export const DASHBOARDS_LOADED = 'DASHBOARDS_LOADED';
export const CURRENT_CARDS_LOADED = 'CURRENT_CARDS_LOADED';
export const ALL_CARDS_LOADED = 'ALL_CARDS_LOADED';
export const DASHBOARD_ADDED = 'DASHBOARD_ADDED';
export const DASHBOARD_UPDATED = 'DASHBOARD_UPDATED';
export const DASHBOARD_DELETED = 'DASHBOARD_DELETED';
export const CURRENT_CARD_UPDATED = 'CURRENT_CARD_UPDATED';
export const CARD_DELETED = 'CARD_DELETED';
export const CARD_ADDED = 'CARD_ADDED';
